module.exports = __webpack_public_path__ + "images/edd51bcd059e0c8bd6536a3ad32a5b06.webp";